import React, { useEffect, useState } from "react";
import GridLayout from "react-grid-layout";

import useElementDimensions from "../../../../hooks/useElementDimensions";
import { elementConfig } from "../../../../utils/Config/DefaultConfig/elementConfig";
import FieldsRedering from "./FieldsRedering";
import IconPreview from "../../../../components/BuilderComponents/Preview/IconPreview";
import { getDropDimensionForDetailview } from "../../../../utils/GridLayoutFunc";
import { useTemplateContext } from "../../../../context/TemplateContext";
import { hasOwn } from "../../../../commonFunctions/arrayFunc";
import { generateObjectId } from "../../../../utils/objectIdUtils";

const RenderNestedGridLayout = ({
  dragFromOutside = false,
  itemId,
  setDragFromOutside,
  nestedGridData,
  layoutData,
  tableRef,
  handleModalAction,
  layout,
  setLayout,
  device,
  tableID,
  isDroppable = true
}) => {
  const [sectionLayout, setSectionLayout] = useState([]);
  const [selectedTabId, setSelectedTabId] = useState("");

  const [{ width: elementWidth }, elementRef] = useElementDimensions();
  const { reactComponent } = useTemplateContext();

  const handleReactComponentDrop = (id, type, grid) => {
    const selectedComponent = reactComponent.find((eachComponent) => eachComponent.id === id);

    if (selectedComponent) {
      const configuration = { ...elementConfig[type] };

      configuration.id = grid.i;
      configuration.type = type;
      configuration.config = selectedComponent;
      configuration.name = selectedComponent.name;

      const newGrid = getDropDimensionForDetailview(grid, type, device);

      layoutData.current[grid.i] = configuration;
      setSectionLayout((otherGrids) => [newGrid, ...otherGrids]);
      setLayout((otherGrids) => [newGrid, ...otherGrids]);
    }
  };

  const onDrop = (elemParams, item, e) => {
    if (!item.i) return;

    let elementType = e.dataTransfer.getData("type");
    let elementID = e.dataTransfer.getData("id");
    let elementName = e.dataTransfer.getData("name");
    if (elementType.length === 0) return;

    //handle react component separately
    if (elementType === "custom-component") {
      handleReactComponentDrop(elementID, elementType, item);
      return;
    }

    setDragFromOutside(false);

    let elementObject = {
      id: item.i,
      i: item.i,
      className: {},
      inline_style: {},
      custom_css: "",
      icon: "",
      colorif: []
    };
    if (
      elementType === "activitycard" ||
      elementType === "activity-recordsview" ||
      elementType === "progress-bar" ||
      elementType === "activity-chart"
    ) {
      elementObject = {
        ...elementObject,
        id: elementID,
        type: elementType,
        display: elementName
      };
    } else {
      const newElementConfig = JSON.parse(JSON.stringify(elementConfig[elementType]));
      elementObject = { ...elementObject, ...newElementConfig };
    }

    if (elementObject.type === "tabview") {
      const newId = generateObjectId();
      const newId2 = generateObjectId();

      const newObj = {
        display: "Tab 1",
        id: newId
      };
      const newObj2 = {
        display: "Tab 2",
        id: newId2
      };

      elementObject.config.headerData = [...elementObject.config.headerData, newObj, newObj2];
      elementObject.config.bodyData[newId] = [];
      nestedGridData.current[newId] = [];
      elementObject.config.bodyData[newId2] = [];
      nestedGridData.current[newId2] = [];
    }
    if (elementObject.type === "section") {
      nestedGridData.current[item.i] = [];
      item.h = 2;
    }

    if (itemId) {
      const newNestedGridData = JSON.parse(JSON.stringify(nestedGridData.current));
      if (layoutData.current[itemId].type === "tabview") {
        newNestedGridData[selectedTabId] = [...newNestedGridData[selectedTabId], item];
        nestedGridData.current = newNestedGridData;
        item.h = 3;
      } else {
        newNestedGridData[itemId] = [...newNestedGridData[itemId], item];
        nestedGridData.current = newNestedGridData;
      }
    }
    layoutData.current[item.i] = elementObject;

    const newItem = getDropDimensionForDetailview(item, elementObject.type, device);

    if (itemId) {
      setSectionLayout([newItem, ...sectionLayout]);
    } else {
      setSectionLayout([newItem, ...sectionLayout]);
      setLayout([newItem, ...layout]);
    }
  };

  const handleLayoutChange = (list) => {
    if (dragFromOutside) return;
    if (itemId) {
      let newNestedGridData = JSON.parse(JSON.stringify(nestedGridData.current));
      if (layoutData.current[itemId].type === "tabview") {
        newNestedGridData[selectedTabId] = list;
      }
      newNestedGridData[itemId] = list;
      nestedGridData.current = newNestedGridData;
      setSectionLayout(list);
      setLayout([...layout]);
    } else {
      setLayout(list);
    }
  };
  const copyNestedElement = (type, data, item) => {
    const newId = generateObjectId();
    const newData = JSON.parse(JSON.stringify(data));
    const newItem = JSON.parse(JSON.stringify(item));

    let sectionArray = JSON.parse(JSON.stringify(sectionLayout));

    let newObj;
    let gridObj;
    if (type === "field") {
      newObj = {
        ...newData,
        i: newId
      };
    } else if (type === "section" || type === "tabview") {
      return;
    } else {
      newObj = {
        ...newData,
        id: newId,
        i: newId
      };
    }
    gridObj = {
      ...newItem,
      i: newId
    };
    layoutData.current[newId] = newObj;
    if (layoutData.current[itemId]?.type === "section" || layoutData.current[itemId]?.type === "tabview") {
      setSectionLayout([...sectionArray, gridObj]);
      nestedGridData.current[itemId] = sectionArray;
    } else {
      setLayout([...layout, gridObj]);
    }
  };

  const deleteNestedElement = (id) => {
    if (itemId) {
      const newArray = sectionLayout.filter((item) => item.i !== id);
      const newNestedGridData = JSON.parse(JSON.stringify(nestedGridData.current));
      if (layoutData.current[itemId].type === "tabview") {
        newNestedGridData[selectedTabId] = newArray;
        nestedGridData.current = newNestedGridData;
      } else if (layoutData.current[itemId].type === "section") {
        newNestedGridData[itemId] = newArray;
        nestedGridData.current = newNestedGridData;
      }
      setSectionLayout(newArray);
    } else {
      const newArray = layout.filter((item) => item.i !== id);
      if (nestedGridData && hasOwn(nestedGridData.current, id)) {
        delete nestedGridData.current[id];
      }
      setLayout(newArray);
    }
  };
  const changeTab = (id) => {
    setSelectedTabId(id);
    setSectionLayout(nestedGridData.current[id]);
  };

  useEffect(() => {
    if (itemId) {
      if (layoutData.current[itemId].type === "tabview") {
        const selecttab = selectedTabId || layoutData.current[itemId].config.headerData[0].id;
        setSelectedTabId(selecttab);
        setSectionLayout(nestedGridData.current[selecttab]);
      } else {
        setSectionLayout(nestedGridData.current[itemId]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nestedGridData?.current]);

  useEffect(() => {
    if (!itemId) {
      setSectionLayout(layout);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layout]);

  const convertClassname = (obj) => {
    const modifiedClassName = Object.values(obj).join(" ");
    return modifiedClassName;
  };
  return (
    <div
      className={`detailsView_inside_page 
    ${convertClassname(layoutData.current[itemId]?.className || {})}`}
      style={{
        ...layoutData.current[itemId]?.inline_style,
        ...(itemId && { marginTop: "0px" })
      }}
    >
      {layoutData.current[itemId]?.type === "tabview" && (
        <div className={`tabView_container `}>
          <div className="d_flex">
            {layoutData.current[itemId].config.headerData.map((tab) => (
              <div
                className="tabView_items"
                style={{ borderBottom: tab.id === selectedTabId ? "1px solid #4a1fb8" : "" }}
                onClick={() => changeTab(tab.id)}
                key={tab.id}
              >
                <span className="tab_header">
                  {tab?.icon && <IconPreview icon={tab.icon || ""} />}
                  {tab.display}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
      <div ref={elementRef}></div>
      <GridLayout
        rowHeight={30}
        cols={12}
        width={elementWidth}
        layout={sectionLayout}
        onDrop={(elemParams, item, e) => onDrop(elemParams, item, e)}
        compactType={"vertical"}
        // compactType={null}
        // preventCollision={true}
        isDroppable={isDroppable}
        droppingItem={{ i: generateObjectId(), h: 1, w: 12 }}
        useCSSTransforms={true}
        onLayoutChange={handleLayoutChange}
        className="draggable_elements_outer"
        onDragStart={(layout, oldItem, newItem, _, e) => e.stopPropagation()}
        margin={[0, 2]}
        // allowOverlap={true}
        // preventCollision={true}
      >
        {sectionLayout?.map((item) => {
          return (
            <div title={layoutData.current[item.i]?.type} key={item.i}>
              <FieldsRedering
                itemId={itemId}
                item={item}
                layoutData={layoutData}
                tableRef={tableRef}
                nestedGridData={nestedGridData}
                dragFromOutside={dragFromOutside}
                setDragFromOutside={setDragFromOutside}
                deleteElement={deleteNestedElement}
                copyElement={copyNestedElement}
                handleModalAction={handleModalAction}
                layout={layout}
                setLayout={setLayout}
                device={device}
                tableID={tableID}
              />
            </div>
          );
        })}
      </GridLayout>
    </div>
  );
};

export default RenderNestedGridLayout;
